module.exports = __webpack_public_path__ + "static/media/KucoinWallet.726dda9e.svg";